
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/azure-blob",
      function () {
        return require("private-next-pages/destinations/azure-blob.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/azure-blob"])
      });
    }
  